<template>
    <v-main>
        <v-container  v-if="blogposts">
            <v-row   v-if="issomethingloading && !blogposts.length">
                <v-col cols="12" class="text-center">
                    <v-progress-circular
                            :size="100"
                            :width="7"
                            color="primary"
                            indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
            <v-row   v-else>
                <v-col cols="12" class="align-center">
                    <v-card flat class="transparent">
                        <v-card-title>
                            <h1>All Articles/Blog Posts</h1>
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col cols="12">
            <ul v-for="blogpost of blogposts" :key="blogpost.id">
                <li>
                    <router-link :to="'/blog/posts/' + blogpost.slug">{{blogpost.title}}</router-link>
                </li>
            </ul>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ListOfAllBlogPosts',
  data: () => ({

    blogposts: [],
    issomethingloading: false,

  }),
  methods: {
    GetAllPosts() {
      this.issomethingloading = true;
      axios.get('content/blogs/posts/barebones/all/')
        .then((response) => {
          this.blogposts = response.data;
        })
        .then(() => { this.issomethingloading = false; })
        .catch((e) => {
          this.errors.push(e);
          this.issomethingloading = false;
        });
    },
  },

  created() {
    this.GetAllPosts();
  },
};
</script>

<style scoped>

</style>
